<template>
  <section class="bar" v-if="!isPreview()">
    <div class="bar__content">
      <div class="bar__items">
        <router-link :to="getInboxUrl()" replace>
          <img class="bar__back" src="@/assets/images/back.svg" alt />
        </router-link>
        <ProfilePhoto :images="chat.profilePhoto"></ProfilePhoto>
        <!-- <img class="bar__photo" :src="chat.profilePhoto[0]" alt /> -->
        <p class="bar__name">
          {{ getFormattedChatName(chat.name) }}
        </p>
        <LangSelect />
        <router-link class="bar__info" :to="getChatProfilePageUrl(chat.id)" replace>
          <img src="@/assets/images/info.svg" alt />
        </router-link>
      </div>
      <!-- / bar__items -->
    </div>
    <!-- / bar__content -->
  </section>
  <!-- / bar -->
</template>

<script>
import ProfilePhoto from "@/components/ProfilePhoto.vue";
import LangSelect from "@/components/LangSelect.vue";

export default {
  name: "Bar",
  components: {
    ProfilePhoto,
    LangSelect,
  },
  props: {
    chat: Object
  },
  methods: {
    getInboxUrl() {
      const { token } = this.$route.query;
      let url = `/${
        this.$route.params.phone_number
      }`;

      if (token) {
        url = `${url}?token=${token}`;
      }
      
      return url;
    },
    getChatProfilePageUrl(id) {
      const { token } = this.$route.query;
      let url = `/${
        this.$route.params.phone_number
      }${this.$store.getters.getChatProfilePageUrl(id)}`;

      if (token) {
        url = `${url}?token=${token}`;
      }
      
      return url;
    },
    getFormattedChatName(chatName) {
      return this.$store.getters.getFormattedChatName(chatName);
    },
    isPreview() {
      const mode = this.$store.getters.getMode;
      return mode && mode === 'preview';
    }
  }
};
</script>

<style lang="scss">
.bar {
  box-shadow: 0 0 8px 0 rgba($txt-color, 0.3);
  padding: 17.5px 20px 17.5px 10px;
  transform: translateX(-50%);
  background-color: $color-bg;
  max-width: $grid-max-width;
  position: fixed;
  z-index: 10;
  width: 100%;
  left: 50%;
  top: 0;

  &__content {
    @include flex(space-between, center, nowrap);
  }

  &__items {
    @include flex(flex-start, center, nowrap);
    width: 100%;
  }

  &__back {
    width: 8px;
    height: 12px;
    margin-right: 12px;
  }

  &__name {
    width: calc(100% - 20px - 20px - 60px);
    text-overflow: ellipsis;
    font-family: $font-alt;
    letter-spacing: 0.48px;
    white-space: nowrap;
    margin-right: 20px;
    color: $txt-color;
    overflow: hidden;
    font-weight: 700;
    font-size: 12px;

    @media #{$bigger-mobile} {
      font-size: 14px;
    }
  }

  &__info {
    @include flex(center, center, nowrap);
    box-shadow: 0px 3px 13px 0 rgba($txt-color, 0.1);
    justify-self: flex-end;
    border-radius: 50%;
    height: 19px;
    width: 19px;

    svg,
    img {
      margin-right: auto;
      margin-left: auto;
      height: 9px;
      width: 5px;
    }
  }

  .profile-thumbnail {
    margin-right: 15px;
    object-fit: cover;
    height: 30px;
    width: 30px;

    &--multiple {
      .profile-thumbnail__photo {
        border-width: 2px;
        width: 22px;
        height: 22px;

        &:nth-of-type(even) {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
</style>
